// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyBsRypVcjJUsAzYefWDYwXL0vFupF_PPwk",
  authDomain: "summitmovistarempresas.firebaseapp.com",
  projectId: "summitmovistarempresas",
  storageBucket: "summitmovistarempresas.appspot.com",
  messagingSenderId: "548338292149",
  appId: "1:548338292149:web:67c8fd9a658c2d6cd775fc",
  measurementId: "G-P0BBTZ2L6D",
};
// firebase/storage
export const storageUrl =
  "https://firebasestorage.googleapis.com/v0/b/summitmovistarempresas.appspot.com/o/";
